import { render, staticRenderFns } from "./property-list-page.vue?vue&type=template&id=a743d15c&"
import script from "./property-list-page.vue?vue&type=script&lang=js&"
export * from "./property-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports